import Vue from 'vue'
import Router from 'vue-router'



Vue.use(Router)

export default new Router({

    //mode: 'history',

    routes: [
        { path: '*', redirect: '/cms/~dashboards~startseite~' },

    
        {
            path: '/cms/:name',
            
            component: () => import( './components/ProcessWireComponent/ProcessWireComponent')
        }
    ]
})
